// Package Imports
import React, { createContext, useContext, useEffect, useState } from 'react';
// Project Imports
import { InputSourceContextType } from 'contexts/resource/inputSourceContext/inputSourceContextType';

const InputSourceContext = createContext<InputSourceContextType>({
  selectFile: null,

  setSelectFile() {
    throw new Error('setCurrent function is not implemented');
  },
  currentStep: 0,
  setCurrentStep() {
    throw new Error('setCurrent function is not implemented');
  },
  isFirstStepCompleted: false,
  setIsFirstStepCompleted() {
    throw new Error('setIsFirstStepCompleted function is not implemented');
  },
  isSecondStepCompleted: false,
  setIsSecondStepCompleted() {
    throw new Error('setIsSecondStepCompleted function is not implemented');
  },
  isWorkflowNeeded: false,
  setIsWorkflowNeeded() {
    throw new Error('setIsWorkflowNeeded function is not implemented');
  },
  setInputSourceId() {
    throw new Error('setCurrent function is not implemented');
  },
  inputSourceId: null,
  setInputSourceFileData() {
    throw new Error('setInputSourceFileData function is not implemented');
  },
  inputSourceFileData: null,
  selectFileObj: null,
  setSelectFileObj() {
    throw new Error('setSelectFileObj function is not implemented');
  },
  dbData: null,
  setDbData() {
    throw new Error('setSelectFileObj function is not implemented');
  },
  toogleFormSubmitApiBuilder: true,
  setToogleFormSubmitApiBuilder() {
    throw new Error('setSelectFileObj function is not implemented');
  },
  apiBuilderData: null,
  setApiBuilderData() {
    throw new Error('setSelectFileObj function is not implemented');
  },
});

export function useInputSourceContext() {
  return useContext(InputSourceContext);
}

const InputSourceProvider = ({ children }: { children: React.ReactNode }) => {
  const [currentStep, setCurrentStep] = useState<any>(() => {
    const storedCurrent = localStorage.getItem('current');
    return Number(storedCurrent) || 0;
  });
  const [selectFile, setSelectFile] = useState(
    () => localStorage.getItem('selectFile') || ''
  );
  const [selectFileObj, setSelectFileObj] = useState(() => {
    const storedSelectFileObj = localStorage.getItem('selectFileObj');
    return storedSelectFileObj ? JSON.parse(storedSelectFileObj) : {};
  });
  const [inputSourceId, setInputSourceId] = useState<any>(
    () => localStorage.getItem('inputSourceId') || null
  );
  const [inputSourceFileData, setInputSourceFileData] = useState(() => {
    const storedinputSourceFile = localStorage.getItem('inputSourceFileData');
    return storedinputSourceFile ? JSON.parse(storedinputSourceFile) : '';
  });
  const [isFirstStepCompleted, setIsFirstStepCompleted] = useState(
    () => localStorage.getItem('isFirstStepCompleted') === 'true'
  );
  const [isSecondStepCompleted, setIsSecondStepCompleted] = useState(
    () => localStorage.getItem('isSecondStepCompleted') === 'true'
  );
  const [isWorkflowNeeded, setIsWorkflowNeeded] = useState(
    () => localStorage.getItem('isWorkflowNeeded') === 'true'
  );
  const [dbData, setDbData] = useState<any>(() => {
    const storedDbData = localStorage.getItem('dbData');
    return storedDbData ? JSON.parse(storedDbData) : {};
  });
  const [toogleFormSubmitApiBuilder, setToogleFormSubmitApiBuilder] =
    useState<boolean>();

  const [apiBuilderData, setApiBuilderData] = useState<any>(() => {
    const storedApiBuilderData = localStorage.getItem('apiBuilderData');
    return storedApiBuilderData ? JSON.parse(storedApiBuilderData) : {};
  });

  useEffect(() => {
    localStorage.setItem('current', currentStep);
  }, [currentStep]);

  useEffect(() => {
    localStorage.setItem('selectFile', selectFile);
  }, [selectFile]);

  useEffect(() => {
    localStorage.setItem('selectFileObj', JSON.stringify(selectFileObj));
  }, [selectFileObj]);

  useEffect(() => {
    localStorage.setItem('inputSourceId', inputSourceId);
  }, [inputSourceId]);

  useEffect(() => {
    localStorage.setItem(
      'inputSourceFileData',
      inputSourceFileData ? JSON.stringify(inputSourceFileData) : ''
    );
  }, [inputSourceFileData]);

  useEffect(() => {
    localStorage.setItem(
      'isFirstStepCompleted',
      isFirstStepCompleted === true ? 'true' : 'false'
    );
  }, [isFirstStepCompleted]);

  useEffect(() => {
    localStorage.setItem(
      'isSecondStepCompleted',
      isSecondStepCompleted === true ? 'true' : 'false'
    );
  }, [isSecondStepCompleted]);

  useEffect(() => {
    localStorage.setItem(
      'isWorkflowNeeded',
      isWorkflowNeeded === true ? 'true' : 'false'
    );
  }, [isWorkflowNeeded]);

  useEffect(() => {
    localStorage.setItem('dbData', JSON.stringify(dbData));
  }, [dbData]);

  useEffect(() => {
    localStorage.setItem('apiBuilderData', JSON.stringify(apiBuilderData));
  }, [apiBuilderData]);

  return (
    <InputSourceContext.Provider
      value={{
        selectFile,
        setSelectFile,
        selectFileObj,
        setSelectFileObj,
        currentStep,
        setCurrentStep,
        setInputSourceId,
        inputSourceId,
        isFirstStepCompleted,
        setIsFirstStepCompleted,
        isSecondStepCompleted,
        setIsSecondStepCompleted,
        isWorkflowNeeded,
        setIsWorkflowNeeded,
        setInputSourceFileData,
        inputSourceFileData,
        setDbData,
        dbData,
        toogleFormSubmitApiBuilder,
        setToogleFormSubmitApiBuilder,
        apiBuilderData,
        setApiBuilderData,
      }}
    >
      {children}
    </InputSourceContext.Provider>
  );
};

export default InputSourceProvider;
